import { toast } from "react-toastify";
import axiosInstance from "../axiosInterceptor";

export const fetchPaginationData = async (
  url,
  requestData,
  setData,
  setTotalCount,
  setCurrentPage,
  setIsLoading,
  setNextSortOrder,
) => {
  setIsLoading && setIsLoading(true);

  try {
    const response = await axiosInstance.post(url, requestData);

    const { data, totalRecords, nextSortOrder } = response.data;

    setData(data);
    setTotalCount(totalRecords);
    setCurrentPage(requestData.pageNo);
    setNextSortOrder && setNextSortOrder(nextSortOrder);
  } catch (error) {
    let message = error?.response?.data?.message;
    toast.error(message);
  } finally {
    setIsLoading && setIsLoading(false);
  }
};
export const deleteItem = async (url, id, fetchDataCallback) => {
  try {
    const response = await axiosInstance.delete(`${url}/${id}`);
    if (response.status === 200) {
      if (fetchDataCallback) fetchDataCallback();
      return response.data;
    } else { 
      return response.data;
    }
  } catch (error) {
    return error?.response?.data;
  }
};
export const deleteMultipleItem = async (url, ids, fetchDataCallback) => {
  try {
    const response = await axiosInstance.post(url, { ids });

    if (response.status === 200) {
      toast.success(response.data?.message || "Items deleted successfully.");
      if (fetchDataCallback) fetchDataCallback();
      return true;
    } else {
      toast.error(response.data?.message || "Failed to delete items.");
      return false;
    }
  } catch (error) {
    toast.error(
      error?.response?.data?.message ||
        "Something went wrong. Please try again!!",
    );
    return false;
  }
};

export const updateStatus = async (fieldId, modelName, isActive) => {
  try {
    const response = await axiosInstance.post(`/status/updateStatus`, {
      fieldId,
      isActive,
      modelName,
    });

    if (response.status === 200) {
      toast.success(response.data?.message);
      return response.data?.data;
    }

    return null;
  } catch (error) {
    toast.error(error.response?.data?.message || "An error occurred");
    return null;
  }
};
export const handleDragEnd = async ({
  result,
  data,
  setData,
  apiEndpoint,
  onSuccess,
  onError,
  model,
  label,
  currentPage = 1,
  perPage = 10,
}) => {
  if (!result.destination) return;

  const items = Array.from(data);

  const [movedItem] = items.splice(result.source.index, 1);
  items.splice(result.destination.index, 0, movedItem);

  const offset = (currentPage - 1) * perPage;
  const updatedData = items.map((item, index) => ({
    ...item,
    sortOrder: offset + index + 1,
  }));

  setData(updatedData);

  const payload = updatedData.map((item) => ({
    id: item._id,
    sortOrder: item.sortOrder,
  }));

  try {
    const response = await axiosInstance.post(apiEndpoint, {
      data: payload,
      model,
      label,
    });

    if (response.data.isSuccess) {
      toast.success(response.data.message);
      onSuccess?.(response.data);
    }
  } catch (error) {
    toast.error(error.response?.data?.message || "Sort update failed");
    onError?.(error);
  }
};

export const getFetchData = async ({ url, setGetData, body }) => {
  try {
    const response = await axiosInstance.get(`${url}`, { body });
    if (response.status === 200) {
      setGetData && setGetData(response.data?.data);
      return response.data?.data;
    }
  } catch (error) {
    toast.error(error.response?.data?.message || "An error occurred");
    return {};
  }
};
